/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAzureResourcePatchDetails {
    getFixupPrototypeFunction() { return PatchManagementAzureResourcePatchDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAzureResourcePatchDetails>): PatchManagementAzureResourcePatchDetails {
        let obj = Object.assign(new PatchManagementAzureResourcePatchDetails(), model);
        PatchManagementAzureResourcePatchDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAzureResourcePatchDetails>): PatchManagementAzureResourcePatchDetails {
        if (!model) return null;
        return PatchManagementAzureResourcePatchDetails.newInstance(<PatchManagementAzureResourcePatchDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAzureResourcePatchDetails) {
        if (!obj) return;

        models.PatchManagementAzureResourcePatchDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAzureResourcePatchDetails): boolean {
        Object.setPrototypeOf(obj, PatchManagementAzureResourcePatchDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.security_count === undefined) {
            this.security_count = 0;
        }
        if (this.other_count === undefined) {
            this.other_count = 0;
        }
        if (this.update_rollup_count === undefined) {
            this.update_rollup_count = 0;
        }
        if (this.feature_pack_count === undefined) {
            this.feature_pack_count = 0;
        }
        if (this.service_pack_count === undefined) {
            this.service_pack_count = 0;
        }
        if (this.definition_count === undefined) {
            this.definition_count = 0;
        }
        if (this.critical_count === undefined) {
            this.critical_count = 0;
        }
        if (this.updates_count === undefined) {
            this.updates_count = 0;
        }
        if (this.tools_count === undefined) {
            this.tools_count = 0;
        }
        if (this.last_installed_count === undefined) {
            this.last_installed_count = 0;
        }
    }

    /**
     * Number of security patches
     */
    security_count: number;

    /**
     * Number of other patches
     */
    other_count: number;

    /**
     * Number of update rollup patches
     */
    update_rollup_count: number;

    /**
     * Number of feature pack patches
     */
    feature_pack_count: number;

    /**
     * Number of service pack patches
     */
    service_pack_count: number;

    /**
     * Number of definition patches
     */
    definition_count: number;

    /**
     * Number of critical patches
     */
    critical_count: number;

    /**
     * Number of update patches
     */
    updates_count: number;

    /**
     * Number of tools patches
     */
    tools_count: number;

    /**
     * Number of patches installed in the last patching operation
     */
    last_installed_count: number;

    /**
     * ID of the last installation activity
     */
    last_installation_activity_id: string;

    /**
     * Flag to indicate if a critical update is required
     */
    critical_update_required: boolean;

    /**
     * Flag to indicate if a security update is required
     */
    security_update_required: boolean;

    /**
     * Flag to indicate if other updates are required
     */
    other_update_required: boolean;

}
